export default "__VITE_ASSET__SFdcpUDK__"